export function extractTopLevelResponseTags(
  response: string,
): Map<string, string> {
  const values = new Map<string, string>()
  const openTags: Array<{ tagName: string, contentStart: number }> = []
  const tagPattern = /<(\/?)\s*(x-[a-z0-9-]+)(?:\s[^<>]*)?>/gi

  let match: RegExpExecArray | null
  while ((match = tagPattern.exec(response)) !== null) {
    const tagName = match[2]?.toLowerCase()
    if (!tagName)
      continue

    if (match[1] !== '/') {
      openTags.push({ tagName, contentStart: tagPattern.lastIndex })
      continue
    }

    const openTag = openTags.at(-1)
    if (!openTag || openTag.tagName !== tagName)
      continue
    openTags.pop()
    const transparentResponseWrapper = openTags.length === 1
      && openTags[0]!.tagName === 'x-response'
    if (
      (openTags.length === 0 || transparentResponseWrapper)
      && !values.has(tagName)
    ) {
      values.set(
        tagName,
        response.slice(openTag.contentStart, match.index),
      )
    }
  }

  return values
}
